module.exports = __webpack_public_path__ + "img/crm_sales2.a3e376d5.png";